import type { IsoDate } from "./types.js";

/**
 * `IsoDate` 的日期運算。前後端共用。
 *
 * 放在 `shared/` 而不是 `src/domain/`：`functions/` 編譯不到 `src/`，日期運算
 * 寫在那邊的話後端就得抄第二份——`shared/prediction.ts` 先前正是這樣，自己
 * 藏了一支私有的 `shiftDays()`。
 *
 * 與 `src/domain/` 的鐵則一致：**不讀系統時間**。「今天」是什麼由呼叫端傳入，
 * 這裡只做「已知的某一天加減幾天」這種算術。取得當地日的 `todayIso()` 留在
 * 呼叫端（前端在 `src/domain/dates.ts`，後端在 `functions/_lib/`）。
 *
 * 日期一律錨定在台北正午（`+08:00`）而不是午夜：加減天數時才不會因為時區
 * 位移跨到前後一天。
 *
 * 這與被它取代的 UTC 版算法**在所有時區都等價**（±400 天、含閏年與月底逐日
 * 比對過，UTC／+14／-11／America~New_York 全部一致）。之所以留下錨定正午的
 * 這一版而不是 UTC 版，是因為 `parseDate` 同時被 `formatDate`、`weekdayOf`
 * 用到，兩種心智模型並存只會讓人每次都要重想一遍。
 */

/** 把 `YYYY-MM-DD` 轉成錨定在台北正午的 `Date`。 */
export function parseDate(value: IsoDate): Date {
  return new Date(`${value}T12:00:00+08:00`);
}

export function daysBetween(from: IsoDate, to: IsoDate): number {
  return Math.round((parseDate(to).getTime() - parseDate(from).getTime()) / 86_400_000);
}

export function addDays(value: IsoDate, amount: number): IsoDate {
  const date = parseDate(value);
  date.setDate(date.getDate() + amount);
  return date.toISOString().slice(0, 10);
}
